import Persistable from "../../storage/persistable";

export default class Season extends Persistable {}
